export default __webpack_public_path__ + "static/media/check.2b94ff76.png";